export default () => {
  return {
    chartFavoritesLocal: [],
    chartFavoritesRegional: [],
    chartFavoritesGlobal: [],
    chartFavoritesLocalLoaded: false,
    chartFavoritesRegionalLoaded: false,
  };
};
